import useOrders from "../orders/use_orders";
import { IconExternalLink } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
function DashboardOrders() {
  const orders = useOrders();
  const navigate = useNavigate();
  return (
    <div>
      <div
        className="text-lg hover:text-blue-600 hover:underline"
        onClick={() => navigate("/orders")}
      >
        New Orders
      </div>
      {orders.state.map((order) => (
        <div className="border p-2 rounded-md flex justify-between">
          <div>
            <div>
              {order.first_name} {order.last_name}
            </div>
            <div>Feedback: {order.feedback_content}</div>
          </div>
          <div className="items-end flex flex-col">
            <div
              className="hover:text-blue-600"
              onClick={() => navigate(`/order/${order.order_id}`)}
            >
              <IconExternalLink />
            </div>
            <div>items ({order.items.length})</div>
          </div>
        </div>
      ))}
    </div>
  );
}
export default DashboardOrders;
